const initialState = {
  progress: 0,
  visible: true,
};

export default initialState;
